export const Cluster = (props: { content: string }) => (
	<div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1 }}>
		<div style={{ fontWeight: 600 }}>{props.content}</div>
		<svg
			style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: -1 }}
			width="48"
			height="48"
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_25124_16087)">
				<circle cx="24" cy="24" r="18" fill="white" />
				<circle cx="24" cy="24" r="20" stroke="#1AB248" strokeWidth="8" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M46.4513 32.5C47.4522 29.8578 48 26.9929 48 24C48 10.7452 37.2548 0 24 0C23.8329 0 23.6663 0.00170713 23.5 0.00510489V8.00766C23.666 8.00257 23.8327 8 24 8C32.8366 8 40 15.1634 40 24C40 27.1231 39.1052 30.0373 37.5579 32.5H46.4513Z"
					fill="#58595B"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M47.8714 26.5C47.9564 25.6783 48 24.8442 48 24C48 10.7452 37.2548 0 24 0C23.665 0 23.3316 0.00686284 23 0.0204556V8.03074C23.3307 8.01035 23.6641 8 24 8C32.8366 8 40 15.1634 40 24C40 24.8505 39.9336 25.6854 39.8058 26.5H47.8714Z"
					fill="#002A47"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M37.5264 32.55C34.6902 37.0275 29.6922 40 24 40C16.268 40 9.817 34.5155 8.32506 27.2246C9.81698 34.5155 16.268 40.0001 24 40.0001C29.6923 40.0001 34.6902 37.0275 37.5264 32.55ZM40 24.0001C40 24 40 24 40 24C40 15.1634 32.8366 8 24 8C23.6642 8 23.3307 8.01035 23 8.03074V0.0205078C10.2089 0.544766 0 11.0802 0 24.0001C0 24 0 24 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 24 48 24 48 24.0001H40ZM8 24.0001C8 24.0001 8 24.0001 8 24.0001V24.0001Z"
					fill="#ED1752"
				/>
			</g>
			<defs>
				<clipPath id="clip0_25124_16087">
					<rect width="48" height="48" fill="white" />
				</clipPath>
			</defs>
		</svg>
	</div>
)
